import React from "react";
import "./styles.scss";

export default function Timeline({ children }) {
  return <div className='timeline-block'>{children}</div>;
}
